import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MapComponent } from './map/map.component';
import { CartComponent } from './cart/cart.component';
import { PaymentComponent } from './payment/payment.component';
import { PayConfirmComponent } from './pay-confirm/pay-confirm.component';
import { SpotComponent } from './spot/spot.component';
import { CreditIAComponent } from './credit-ia/credit-ia.component';

const routes: Routes = [
    { path: '', component: MapComponent },
    { path: 'cart', component: CartComponent },
    { path: 'spot', component: SpotComponent },
    { path: 'pay', component: PaymentComponent },
    { path: 'pay-confirm/:orderId', component: PayConfirmComponent },
    // { path: 'creditIA', component: CreditIAComponent }, // Achat de crédits IA directement dans Wanview
];

@NgModule({
    declarations: [],
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class StoreRoutingModule {}
